import { Img } from '#src/atoms/ui/Img/index.tsx';

type Props = {
  alt?: string;
  className?: string;
  picture: string;
  height?: number;
  width?: number;
};

export const Picture = ({ className, picture, alt, height, width }: Props) => {
  return (
    <picture className={className}>
      <Img src={picture} alt={alt} height={height} width={width} />
    </picture>
  );
};
